import React from 'react'
import styled from '@emotion/styled'
import { gsColors } from '../../../../styles/Variables'
import Color from 'color'
import { mq } from '../../../../helpers'
import LoadingDot from './LoadingDot'

const ButtonStyle = styled.button`
  background-color: ${props =>
    props.backgroundColor ? gsColors[props.backgroundColor] : gsColors.grape};
  border: 0;
  color: ${gsColors.white};
  cursor: pointer;
  display: flex;
  justify-content: ${props =>
    props.justifyContent ? props.justifyContent : 'center'};
  align-items: center;
  font-family: Brown, sans-serif;
  font-size: 18px;
  font-weight: bold;
  padding: 0 20px;
  transition: background-color 250ms;
  width: 100%;
  height: 60px;

  &[disabled] {
    cursor: default;

    ${props =>
    !props.working &&
    `background-color: ${Color(gsColors.grape).alpha(0.3).string()};`}
  }

  &.secondary {
    background-color: ${gsColors.white};
    border: 1px solid ${gsColors.honeyFlower};
    color: ${gsColors.honeyFlower};
  }

  &.fb-login {
    background-color: ${gsColors.white};
    border: 1px solid ${gsColors.facebook};
    color: ${gsColors.facebook};
    font-size: 12px;
    height: 48px;
    letter-spacing: 1px;
    position: relative;
    text-transform: uppercase;

    ${mq('min', '768px')} {
      margin-left: auto;
      margin-right: auto;
      max-width: 330px;
    }

    img {
      // fill: ${gsColors.facebook};
      margin-right: 8px;
      width: 21px;
      height: 21px;
    }

    span {
      margin-top: 5px;
    }
  }

  &.payment {
    &[disabled] {
      background-color: ${gsColors.prim};
      border-color: ${gsColors.prim};

      svg {
        margin: 0 16px 4px 0;
        width: 14px;
        height: 11px;

        g {
          fill: ${gsColors.honeyFlower};
        }
      }
    }
  }

  &.alternate-time {
    font-family: Euclid;
    background-color: ${gsColors.white};
    border: 1px solid #000;
    color: ${gsColors.black};
    font-size: 16px;
    font-weight: normal;
    margin: 8px;
    padding: 0 15px;
    width: auto;
    height: 40px;
    
    &:hover {
      border: 1px solid ${gsColors.sunsetOrange};
      color: ${gsColors.sunsetOrange};
    }
  }
`

const Button = (props) => {
  const color = props.payment ? gsColors.honeyFlower : gsColors.white

  return (
    <ButtonStyle {...props}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      {props.className === 'fb-login' && !props.working && <img src='/images/facebook.svg' alt='Facebook' />}
      {/* eslint-disable-next-line @next/next/no-img-element */}
      {props.disabled && props.payment && !props.working && <img src='/images/checkmark.svg' alt='' aria-hidden='true' />}
      {!props.working && props.children}
      {props.working && <LoadingDot {...{ color }} />}
    </ButtonStyle>
  )
}
export default Button
